
export default {
  name: 'EoMain',
  computed: {
    styles () {
      return {
        paddingBottom: this.$parent.spaceForFooter + 'px',
      }
    },
  },
  created () {
    this.$parent.hasMain = true
  },
}
